import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-seguro',
    templateUrl: './seguro.component.html',
    styleUrls: ['./seguro.component.css'],
    imports: []
})
export class SeguroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
